import { useRef } from 'react';
import { toast } from 'sonner';
import { ImagePlus, Trash2 } from 'lucide-react';

const MAX_PX = 600;

const toPngBase64 = (file) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    const scale = Math.min(1, MAX_PX / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    URL.revokeObjectURL(img.src);
    resolve(canvas.toDataURL('image/png').split(',')[1]);
  };
  img.onerror = reject;
  img.src = URL.createObjectURL(file);
});

export const AtelierLogoField = ({ config, setConfig }) => {
  const inputRef = useRef(null);
  const width = config.invoice_logo_width || 40;

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.error('Choisissez une image (PNG, JPG)'); return; }
    try {
      const b64 = await toPngBase64(file);
      setConfig(prev => ({ ...prev, logo_base64: b64 }));
      toast.success('Logo prêt — cliquez Enregistrer');
    } catch { toast.error('Image illisible'); }
  };

  return (
    <div className="border-t border-slate-800 pt-4 space-y-3" data-testid="atelier-logo-field">
      <div>
        <p className="text-xs text-slate-400">Logo des factures atelier</p>
        <p className="text-[11px] text-slate-500">Indépendant du logo de la facturation générale.</p>
      </div>
      <div className="flex items-center gap-3">
        <div className="w-40 h-20 rounded-lg border border-dashed border-slate-700 bg-white/95 flex items-center justify-center overflow-hidden">
          {config.logo_base64
            ? <img src={`data:image/png;base64,${config.logo_base64}`} alt="Logo atelier" className="max-h-full max-w-full object-contain" data-testid="atelier-logo-preview" />
            : <span className="text-[11px] text-slate-500">Aucun logo</span>}
        </div>
        <div className="flex flex-col gap-2">
          <button type="button" onClick={() => inputRef.current?.click()}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-800 border border-slate-700 text-white text-xs" data-testid="atelier-logo-upload-btn">
            <ImagePlus size={14} /> {config.logo_base64 ? 'Changer' : 'Ajouter un logo'}
          </button>
          {config.logo_base64 && (
            <button type="button" onClick={() => setConfig(prev => ({ ...prev, logo_base64: null }))}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-red-500/10 text-red-400 text-xs" data-testid="atelier-logo-remove-btn">
              <Trash2 size={14} /> Retirer
            </button>
          )}
        </div>
        <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={onFile} data-testid="atelier-logo-input" />
      </div>
      {config.logo_base64 && (
        <label className="block text-xs text-slate-400">
          Largeur sur la facture : {width} mm
          <input type="range" min="20" max="70" step="5" value={width}
            onChange={e => setConfig(prev => ({ ...prev, invoice_logo_width: Number(e.target.value) }))}
            className="w-full accent-amber-500" data-testid="atelier-logo-width" />
        </label>
      )}
    </div>
  );
};
